import React, { Component } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCaretDown,
  faCheckCircle,
  faPlaneDeparture,
} from "@fortawesome/free-solid-svg-icons";
import { Redirect } from "react-router";

import { AirportFullName } from "../../../service/shared/AirportFullName";
import HttpService from "../../../service/shared/HttpService";
import Loading from "../../booking/seat-selection/Loading";
import { searchFlightAction } from "../../../redux/actions/booking/searchFlightAction";
import { flightSelectionAction } from "../../../redux/actions/booking/flightSelectionAction";
import ExchangeFlightSelectionDetail from "./ExchangeFlightSelectionDetail";
import { exchangeAction } from "../../../redux/actions/exchange/exchangeAction";
class ExchangeFlightSelectionSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToPassenger: false,
      redirectToHome: false,
      redirectToSelection: false,
      redirectToPayment: false,
      isLoading: false,
    };
  }
  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  parseTime = (minute) => {
    let hours = parseInt(minute / 60);
    let minutes = minute % 60;
    return <span>{hours + "hrs " + minutes + " mins"}</span>;
  };
  parseDate = (dateString) => {
    let time = moment(dateString)
      .locale(localStorage.getItem("i18nextLng"))
      .format("LT");

    let newDate = moment(dateString)
      .locale(localStorage.getItem("i18nextLng"))
      .format("DD MMMM YYYY");
    return (
      <span>
        {newDate} {time}{" "}
      </span>
    );
  };
  renderStops(segments, stops, key) {
    if (stops > 0) {
      if (segments.length > 1) {
        return (
          <span>
            <span>{stops > 1 ? stops + " Stops " : stops + " Stop "}</span>
            {/* {segments.map(
              (segment, index) =>
                index != 0 && <span key={index}>{segment.origin}</span>
            )} */}
          </span>
        );
      } else {
        return (
          <span>
            <span>{stops > 1 ? stops + " Stops " : stops + " Stop "}</span>
            {/* {segments.map((segment, index) => (
              <span key={index}>
                {segment.flight.stopAirports.map((airport, index2) => (
                  <span key={index2}>{airport.airport} </span>
                ))}
              </span>
            ))} */}
          </span>
        );
      }
    } else {
      return <span>Non-stop</span>;
    }
  }
  renderAirportName(airportCode) {
    let airportName = AirportFullName.getFullName(airportCode);
    return <span>{airportName}</span>;
  }
  redirectToPassenger() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.setState({ redirectToPayment: true, redirectToHome: false });
  }
  redirectToHome() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.setState({ redirectToPassenger: false, redirectToHome: true });
  }
  changeFlight = () => {
    let searchRequest = this.props.flightSearchRequest;

    this.setState({ isLoading: true });
    HttpService.postServiceExchange(
      searchRequest,
      "/etibe-exchangeapi/V1.0/Availability/SearchFlights",
      this.props.searchFlight.token
    )
      .then((response) => {
        if (response.data.statusAPI === "SUCCESS") {
          window.scrollTo({ top: 0, behavior: "smooth" });
          this.props.updateFlightSearchResult(response);
          this.setState({ redirectToSelection: true, isLoading: false });
        } else {
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });

        console.log(error);
      });
  };
  render() {
    if (this.state.redirectToHome) {
      return (
        <Redirect
          to={{
            pathname: "/",
          }}
        />
      );
    }
    if (this.state.redirectToPassenger) {
      return (
        <Redirect
          to={{
            pathname: "/exchange/passenger",
          }}
        />
      );
    }
    if (this.state.redirectToPayment) {
      return (
        <Redirect
          to={{
            pathname: "/exchange/payment-option",
          }}
        />
      );
    }
    if (this.state.redirectToSelection) {
      return (
        <Redirect
          to={{
            pathname: "/exchange/flight-selection",
          }}
        />
      );
    }
    return (
      <>
        {/* <BreadCrumb /> */}
        <Row className="m-0 flex-column-reverse flex-xl-row w-100 justify-content-center all-passangers-container">
          <div className="col-12 col-xl-7 mx-auto mx-xl-0">
            <div className="mt-4 mx-auto mr-xl-0">
              {this.state.isLoading && <Loading />}
              <div>
                <h4 className="py-3 selected-flight-review-txt">
                  Review Your Flight Selections
                </h4>
              </div>

              <div className="flight-selection-summary selected-itinerary-part-offer">
                {this.props.flightSearchResult.map((itineraryPart, key) => (
                  <div className="bg-white" key={key}>
                    {key > 0 && <hr className="m-0" />}
                    {key === 0 && (
                      <Row className="selected-itinerary-part-offer-head-info">
                        <Col sm={12} md={7} lg={6}>
                          <div className="selected-itinerary-part-offer-date">
                            <span className="pr-2 selected-itinerary-part-mark-icon">
                              <FontAwesomeIcon icon={faCheckCircle} />
                            </span>
                            <span>
                              {moment(itineraryPart.segments[0].departure)
                                .locale(localStorage.getItem("i18nextLng"))
                                .format("dddd, MMMM Do")}
                            </span>
                          </div>
                        </Col>
                        <Col sm={12} md={5} lg={6}>
                          <div className="float-right">
                            <span>
                              <Button
                                className="bk-submit-btn btn-ethiopian ml-2"
                                onClick={() => this.changeFlight()}
                              >
                                Change Flight
                              </Button>
                            </span>
                          </div>
                        </Col>
                      </Row>
                    )}
                    <Row className="m-0 selected-itinerary-part-offer-info">
                      <Col>
                        <Row>
                          <Col xs={12} sm={12} md={4}>
                            <div>
                              <span>
                                {this.parseDate(
                                  itineraryPart.segments[0].departure
                                )}
                              </span>
                            </div>
                          </Col>
                          <Col xs={12} sm={12} md={4}>
                            <div>
                              <span>
                                {this.parseDate(
                                  itineraryPart.segments[
                                    itineraryPart.segments.length - 1
                                  ].arrival
                                )}
                              </span>
                            </div>
                          </Col>
                          <Col xs={12} sm={12} md={4}>
                            <div>
                              <span>
                                {this.parseTime(itineraryPart.totalDuration)}
                              </span>
                            </div>
                          </Col>
                        </Row>
                        <Row className="py-2">
                          <Col xs={5} sm={5} md={3}>
                            <div>
                              <span className="segment-info-airportcode">
                                {itineraryPart.segments[0].origin}
                              </span>
                            </div>
                          </Col>
                          <Col xs={2} sm={2}>
                            <div>
                              <span>
                                <FontAwesomeIcon icon={faPlaneDeparture} />
                              </span>
                            </div>
                          </Col>
                          <Col xs={5} sm={5} md={3}>
                            <div>
                              <span className="segment-info-airportcode">
                                {
                                  itineraryPart.segments[
                                    itineraryPart.segments.length - 1
                                  ].destination
                                }
                              </span>
                            </div>
                          </Col>
                          <Col>
                            <div className="sm-text-center">
                              <span>
                                {this.renderStops(
                                  itineraryPart.segments,
                                  itineraryPart.stops,
                                  key
                                )}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={12} md={4}>
                        <div className="float-right">
                          {/* <span>Economy Semi Flex</span> */}
                        </div>
                      </Col>
                      <Col xs={12} className="py-2">
                        {itineraryPart.segments.map((segment, index) => (
                          <div className="py-1" key={index}>
                            {segment.flight.airlineCode === "ET" && (
                              <img
                                className="custom-img-sm-flag"
                                src="data:image/png;base64,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"
                              />
                            )}
                            <span className="px-1">
                              {segment.flight.airlineCode}
                            </span>
                            <span className="pr-2">
                              {segment.flight.flightNumber}
                            </span>
                            <span className="pr-2">
                              {segment.manufacturerName}
                            </span>
                            <span>{segment.equipmentDescription}</span>
                          </div>
                        ))}
                      </Col>
                      {key === this.props.flightSearchResult.length - 1 && (
                        <Col xs={12} className="mt-3 pl-1">
                          <ExchangeFlightSelectionDetail
                            itineraryPart={this.props.flightSearchResult}
                          />
                        </Col>
                      )}
                    </Row>
                  </div>
                ))}
              </div>
              <br />
              <Row>
                <Col sm={12} md={6}></Col>
                <Col sm={12} md={6}>
                  <div className="float-right">
                    <Button
                      className="bk-submit-btn btn-ethiopian mx-2"
                      onClick={() => this.redirectToHome()}
                    >
                      <FontAwesomeIcon icon={faArrowLeft} />
                    </Button>
                    <Button
                      className="bk-submit-btn btn-ethiopian ml-2"
                      onClick={() => this.redirectToPassenger()}
                    >
                      CONTINUE
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          {/* <div className="col-12 col-xl-3">
            {!this.props.isMedium && <ShoppingCart />}
          </div> */}
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    flightSearchResult: state.exchange.flightSelectionResult.itineraryParts,
    journeyType: state.bookingWiget.journyType,
    searchFlight: state.searchFlight,
    isMedium: state.global.isMedium,
    flightSearchRequest: state.exchange.flightSearchRequestForConfirmation,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateFlightIndex: (index) => {
      dispatch({
        type: flightSelectionAction.UPDATEFLIGHTINDEX,
        flightIndex: index,
      });
    },
    saveSearchResult: (result) =>
      dispatch({
        type: searchFlightAction.SAVESEARCHRESULT,
        searchResult: result,
      }),
    updateFlightSearchResult: (searchResult) => {
      dispatch({
        type: exchangeAction.SAVEFLIGHTSEARCHRESULT,
        value: searchResult,
      });
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExchangeFlightSelectionSummary);
